module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vpelv7-901a5c2f3c64b9135413c470b382d3fe.jpg";